import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import Lottie from "lottie-react";

import { Button } from "../components/ui/button";
import { uploadContract } from "../lib/contract";
import { setFileStore } from "../../store/file-slice";

import type { RootState } from "../../store/store";

import animationData from "../../../assets/Search document.json";
import ErrorComponent from "../../utils/components/ErrorComponent";
import NoDocument from "../../utils/components/NoDocument";

async function getDocumentContent(): Promise<{ arr: string[]; fileName: string }> {
	return Word.run(async (context) => {
		const paragraphs = context.document.body.paragraphs;
		paragraphs.load("items");
		await context.sync();

		const arr = paragraphs.items.map((p) => p.text);

		const url = Office.context.document.url;
		let fileName: string;
		if (url) {
			fileName = url.substring(url.lastIndexOf("/") + 1);
		}

		return { arr, fileName };
	});
}

export function Home() {
	const dispatch = useDispatch();

	const contractId = useSelector((state: RootState) => state.files.fileId);

	const uploadOpenDoc = useMutation({
		mutationFn: uploadContract,
		onSuccess: (data) => {
			dispatch(
				setFileStore({
					fileId: data.fileIds[0].fileId,
					fileType: {
						value: data.fileIds[0].code,
						label: data.fileIds[0].name,
					},
				})
			);
		},
	});

	useEffect(() => {
		async function uploadDoc() {
			const { arr, fileName } = await getDocumentContent();

			if ((arr.length === 1 && arr[0].length !== 0) || arr.length !== 1) {
				uploadOpenDoc.mutate({ fileName });
			}
		}

		if (!contractId) {
			uploadDoc();
		}
	}, []);

	if (uploadOpenDoc.isPending) {
		return (
			<div className="flex flex-col justify-center gap-2 items-center text-center h-full">
				<Lottie animationData={animationData} loop autoplay style={{ width: "85px", height: "85px" }} />
				<p className="text-[14px] font-bold mb-2 text-[#424165] max-w-3xs text-center">
					Your document is loading this may take up to 1 minute Please Wait ...
				</p>
			</div>
		);
	}

	if (uploadOpenDoc.isError) {
		return <ErrorComponent open={true} message={uploadOpenDoc.error.message} errorId={null} />;
	}

	// loading state when document is getting uploaded
	if (uploadOpenDoc.isSuccess || !!contractId) {
		return (
			<div className="flex flex-col items-center justify-center h-full">
				<p className="text-[20px] font-semibold mb-2 text-[#424165]">Ready to analyze</p>
				<Link to="/analyze">
					<Button>Start Analysis</Button>
				</Link>
			</div>
		);
	}

	return <NoDocument />;
}
